import { Link, useLocation } from "react-router-dom";
import { sfaCategory } from "./SfaSidebar";
import { cn } from "../../lib/utils";
import {
  LayoutDashboard, Users, Building2, PhoneForwarded, CalendarDays, Calendar, StickyNote,
  Phone, Megaphone, Layers, UserCheck, Copy, PhoneOff, Headset, Clock, Shield
} from "lucide-react";

const tabs: Record<string, Array<{ label: string; href: string; icon: React.ElementType }>> = {
  sales: [
    { label: "Overview", href: "/crm", icon: LayoutDashboard }, 
    { label: "Leads", href: "/crm/leads", icon: Users }, 
    { label: "Customers", href: "/crm/customers", icon: Building2 }, 
    { label: "Follow-ups", href: "/crm/follow-ups", icon: PhoneForwarded }, 
    { label: "Appointments", href: "/crm/appointments", icon: CalendarDays }, 
    { label: "Calendar", href: "/crm/calendar", icon: Calendar }, 
    { label: "Notes", href: "/crm/notes", icon: StickyNote }
  ],
  calling: [
    { label: "Campaigns", href: "/crm/campaigns", icon: Megaphone },
    { label: "Dialer", href: "/crm/dialer", icon: Phone },
    { label: "Batches", href: "/crm/batches", icon: Layers }
  ],
  management: [
    { label: "Assignment", href: "/crm/assignment", icon: UserCheck }, 
    { label: "Duplicates", href: "/crm/duplicates", icon: Copy }, 
    { label: "DND list", href: "/crm/suppression", icon: PhoneOff }, 
    { label: "Agents", href: "/crm/agents", icon: Headset },
    { label: "SLA", href: "/crm/sla", icon: Clock },
    { label: "Users & roles", href: "/crm/users", icon: Shield }
  ],
};

export function SfaSectionTabs() { 
  const { pathname } = useLocation(); 
  const category = sfaCategory(pathname); 
  
  return (
    <nav aria-label="SFA sections" className="shrink-0 overflow-x-auto px-4 py-1.5 border-b border-line bg-background">
      <div className="flex w-full gap-0.5 p-0.5 rounded-lg bg-soft border border-line">
        {tabs[category].map((tab) => {
          const isActive = pathname === tab.href;
          const Icon = tab.icon;
          return (
            <Link 
              key={tab.href} 
              to={tab.href} 
              className={cn(
                "flex flex-1 flex-col items-center justify-center gap-0.5 min-w-[62px] px-2 py-1 rounded-md text-[11px] font-medium transition-all duration-150", 
                isActive 
                  ? "bg-elevated shadow-xs text-brand font-semibold border border-line/80" 
                  : "text-ink-3 hover:text-ink hover:bg-black/[0.03] dark:hover:bg-white/5 border border-transparent"
              )}
            >
              <Icon className={cn("w-3.5 h-3.5", isActive ? "text-brand" : "text-ink-3")} strokeWidth={isActive ? 2.2 : 1.8} />
              <span className="leading-tight text-[11px]">{tab.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  ); 
}
